/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.modalArrow[_ngcontent-%COMP%] { font-size : 30px; border : none; background : none }\n.modalArrow[_ngcontent-%COMP%]:hover { color : black; }\n.view[_ngcontent-%COMP%]   .tools[_ngcontent-%COMP%] { margin: 305px 0 0 0;}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvZ2l0bGFiLXJ1bm5lci9idWlsZHMvZDkwYzViY2YvMC9nYWlhL2dhaWEtdWktYW5ndWxhci9zcmMvYXBwL3NpZ24vbGlzdC9zaWduLWxpc3QuY29tcG9uZW50LmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL2dpdGxhYi1ydW5uZXIvYnVpbGRzL2Q5MGM1YmNmLzAvZ2FpYS9nYWlhLXVpLWFuZ3VsYXIvc3JjL2FwcC9zaWduL2xpc3Qvc2lnbi1saXN0LmNvbXBvbmVudC5jc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/$$_gendir/app/sign/list/sign-list.component.css.shim.ngstyle.ts